module.exports = __webpack_public_path__ + "img/light-three-dots.66cff077.svg";